module.exports = __webpack_public_path__ + "static/media/icono-tomate-knorr-compradores.5c67ea0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icono-tomate-knorr-compradores.png
// module id = 309
// module chunks = 0